// extracted by mini-css-extract-plugin
export default {"metricValue":"CampaignMetrics_metricValue__HiXMt"};